import { Component, OnInit, Input, EventEmitter, Renderer2, SimpleChanges, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { RecSearchService } from '../../rec-search-service';
import { InstrumentVM, RecDocVM } from '../../../shared/viewmodels/ISearchService';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
//import { ImageViewerComponent } from '../../../shared/components/image-viewer/image-viewer.component';

import { RecDocDetailParentComponent } from '../../components/rec-doc-detail-parent/rec-doc-detail-parent.component';

@Component({
  selector: 'app-rec-docnum-doc-disp-pg',
  providers: [RecSearchService],
  templateUrl: './rec-docnum-doc-disp-pg.component.html',
  styleUrls: ['./rec-docnum-doc-disp-pg.component.css']
})
export class RecDocnumDocDispPgComponent implements OnInit, OnDestroy {

  public docId: number;
  public book: string;
  public page: string;
  collapsesideinfo: boolean = false;
  public record: RecDocVM;
  error: any;
  public isImgVwVisible: boolean = true;
  public isLoadingDetail: boolean = true;
  @ViewChild(RecDocDetailParentComponent, { static: false }) recDocDetailParentChild;
  screenWidth: any;


  constructor(private route: ActivatedRoute,
    private service: RecSearchService,
    private router: Router, private renderer: Renderer2, public nav: NavMenuService) {
    this.docId = Number(this.route.snapshot.paramMap.get('docId'));
    this.nav.hide();
  }

  /** Initialize image viewer */
  ngOnInit() {
    console.log('ngOnInit() fired');
    console.log('Calling loadImageByBookPage() from ngOnInit ');

    this.isLoadingDetail = true;
    this.service.getRecDoc(this.docId).subscribe(
      data => {
        this.record = data;
        this.book = data.docDetail.primaryID;
        this.page = data.docDetail.secondaryID;
        this.isLoadingDetail = false;
      },
      error => { this.error = error }
    );
  }

  /**
    * Navigate to previous page.
    * @param url
    */
  back(url) {
    this.router.navigate([url]);
    this.nav.show();

  }


  toggleSideInfo() {
    this.collapsesideinfo = !this.collapsesideinfo;

  }

  loadRef(e: InstrumentVM) {
    console.log(`loadRef fired: ${e}`);
    this.isLoadingDetail = true;
    this.docId = e.docID;
    this.book = e.primaryID;
    this.page = e.secondaryID;
    this.recDocDetailParentChild.loadRef(e);
    this.isLoadingDetail = false;
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  getIsImgVwVisible(e) {
    this.isImgVwVisible = e;
  }

  loadInfo(e: RecDocVM) {
    this.record = e;
  }

  ngOnDestroy() {
    this.nav.show();
  }

}


